import { connect } from 'react-redux';
import { IApplicationState, TTypedThunkDispatch } from '../../../../types/store';
import { changeAreaRange } from '../../../../store/filters/actions';
import { AreaFilter, IAreaFilterProps } from './area_filter';

export function mapStateToProps(state: IApplicationState): Partial<IAreaFilterProps> {
  return {
    areaFrom: state.filters.areaFrom ?? undefined,
    areaTo: state.filters.areaTo ?? undefined,
  };
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch): Partial<IAreaFilterProps> {
  return {
    onChange: (min, max) => dispatch(changeAreaRange(min, max)),
  };
}

export const AreaFilterContainer = connect<Partial<IAreaFilterProps>, Partial<IAreaFilterProps>>(
  mapStateToProps,
  mapDispatchToProps,
)(AreaFilter);
